import { ECoworkingOfferType } from 'shared/repositories/coworking/entities/offer/OfferV2Schema';
import { EObjectType } from 'shared/utils/formatters/getCustomUrl';

export enum EStageTypes {
  filling,
  success,
  error,
}

export type IFormStages = {
  [key in EStageTypes]: { next: EStageTypes };
};

export const formStages: IFormStages = {
  [EStageTypes.filling]: { next: EStageTypes.success },
  [EStageTypes.success]: { next: EStageTypes.filling },
  [EStageTypes.error]: { next: EStageTypes.filling },
};

export const MODAL_WIDTH = 688;
export const MODAL_MAX_WIDTH = MODAL_WIDTH;

export const gaObjectByModalType = {
  [ECoworkingOfferType.Office]: EObjectType.FLEX_OFFICE,
  [ECoworkingOfferType.FixedWorkplace]: EObjectType.FIXED_PLACE,
  [ECoworkingOfferType.FlexibleWorkplace]: EObjectType.FLEX_PLACE,
};
